var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grey lighten-4"},[_c('locationnetworksummary',{attrs:{"locationnetworksummary":_vm.locationNetworkInfo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }